<section class="perfil" [class.perfil--compacto]="compacto" *ngIf="telefoneCompleto && (perfil || carregando || semHistorico || erro)"
         aria-label="Perfil do cliente" [attr.aria-busy]="carregando">
  <header class="perfil__header">
    <span class="perfil__symbol" aria-hidden="true"><i class="mdi mdi-account-heart-outline"></i></span>
    <div class="perfil__heading">
      <span class="perfil__eyebrow">PERFIL DO CLIENTE</span>
      <h3 *ngIf="perfil">{{ perfil.totalPedidos }} {{ perfil.totalPedidos === 1 ? 'pedido' : 'pedidos' }} nos últimos 12 meses
        <small *ngIf="clienteDesde">· desde {{ clienteDesde }}</small></h3>
      <h3 *ngIf="!perfil && semHistorico">Ainda sem pedidos nesta loja</h3>
      <h3 *ngIf="!perfil && carregando">Lendo o histórico…</h3>
    </div>
    <span class="perfil__chip" *ngIf="perfil?.canal?.jaPediuPelaMia" title="Já fechou pedido conversando com a Mia">
      <i class="mdi mdi-robot-outline" aria-hidden="true"></i> Já pediu pela Mia
    </span>
  </header>

  <div class="perfil__loading" *ngIf="carregando && !perfil" role="status"><span></span><span></span></div>

  <dl class="perfil__rows" *ngIf="perfil">
    <div class="perfil__row" *ngIf="canal">
      <dt><i class="mdi mdi-swap-horizontal" aria-hidden="true"></i> Como pede</dt>
      <dd><strong>{{ canal }}</strong><small *ngIf="perfil.canal.evidencia">{{ perfil.canal.evidencia }}</small></dd>
    </div>
    <div class="perfil__row" *ngIf="recebimento">
      <dt><i class="mdi mdi-moped-outline" aria-hidden="true"></i> Recebimento</dt>
      <dd><strong>{{ recebimento }}</strong><small *ngIf="perfil.entrega.evidencia">{{ perfil.entrega.evidencia }}</small></dd>
    </div>
    <div class="perfil__row" *ngIf="perfil.endereco?.habitual">
      <dt><i class="mdi mdi-map-marker-outline" aria-hidden="true"></i> Endereço</dt>
      <dd><strong>{{ perfil.endereco.habitual.descricao }}</strong><small *ngIf="perfil.endereco.evidencia">{{ perfil.endereco.evidencia }}</small></dd>
    </div>
    <div class="perfil__row" *ngIf="perfil.pagamento?.habitual">
      <dt><i class="mdi mdi-credit-card-outline" aria-hidden="true"></i> Pagamento</dt>
      <dd><strong>{{ perfil.pagamento.habitual.descricao }}</strong><small *ngIf="perfil.pagamento.evidencia">{{ perfil.pagamento.evidencia }}</small></dd>
    </div>
    <div class="perfil__row" *ngIf="perfil.ultimoPedido">
      <dt><i class="mdi mdi-history" aria-hidden="true"></i> Último pedido</dt>
      <dd>
        <strong>{{ quandoFoiOUltimo }} · {{ perfil.ultimoPedido.status }} · {{ perfil.ultimoPedido.total | currency:'BRL':'symbol':'1.2-2' }}</strong>
        <small *ngIf="perfil.ultimoPedido.resumo">{{ perfil.ultimoPedido.resumo }}</small>
      </dd>
    </div>
  </dl>

  <p class="perfil__hint" *ngIf="perfil && !compacto">Hábitos são sugestão: confirme com o cliente antes de fechar. Troco é sempre perguntado.</p>

  <div class="perfil__error" *ngIf="erro" role="alert">
    <i class="mdi mdi-alert-circle-outline" aria-hidden="true"></i><span>{{ erro }}</span>
    <button type="button" (click)="carregue()" [disabled]="carregando">Tentar de novo</button>
  </div>
</section>
